import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Tabbar } from 'react-vant'
import { CalendarO, WapHome, UserO, ChatO } from '@react-vant/icons'

// 教师端与学生端统一导航定义
const teacherTabs = [
  { name: '/', icon: <WapHome />, text: '工作台' },
  { name: '/hub', icon: <ChatO />, text: '校园广场' },
  { name: '/sports', icon: <CalendarO />, text: '校园体育' },
  { name: '/profile', icon: <UserO />, text: '我的' },
]

const studentTabs = [
  { name: '/student', icon: <WapHome />, text: '工作台' },
  { name: '/student/hub', icon: <ChatO />, text: '校园广场' },
  { name: '/student/sports', icon: <CalendarO />, text: '校园体育' },
  { name: '/student/profile', icon: <UserO />, text: '我的' },
]

export default function TabBarLayout({ type = 'teacher' }) {
  const location = useLocation()
  const navigate = useNavigate()
  const tabs = type === 'teacher' ? teacherTabs : studentTabs

  const onChange = (v) => {
    navigate(v)
  }

  const isRootPage = tabs.some(tab => tab.name === location.pathname)

  return (
    <div className="flex flex-col h-screen" style={{ background: 'var(--canvas-bg, #f5f8f6)' }}>
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
      {isRootPage && (
        <Tabbar
          value={location.pathname}
          onChange={onChange}
          fixed
          placeholder
          activeColor="#056b4f"
          inactiveColor="#94a3b8"
          style={{
            borderTop: '1px solid #e7ede9',
            background: '#ffffff',
            boxShadow: '0 -2px 14px rgba(5, 107, 79, 0.05)',
            zIndex: 100,
            paddingTop: '4px',
            paddingBottom: '2px',
          }}
        >
          {tabs.map((tab) => {
            const active = location.pathname === tab.name
            return (
              <Tabbar.Item 
                key={tab.name} 
                icon={
                  <div style={{
                    padding: '3px 12px',
                    borderRadius: '14px',
                    background: active ? '#e8f6f0' : 'transparent',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.2s ease',
                  }}>
                    {tab.icon}
                  </div>
                } 
                name={tab.name}
              >
                <span style={{ fontWeight: active ? 700 : 500, fontSize: '11px' }}>
                  {tab.text}
                </span>
              </Tabbar.Item>
            )
          })}
        </Tabbar>
      )}
    </div>
  )
}
